import { Link, useNavigate, useLocation } from "react-router-dom";

const tryScroll = (hash, attempts = 0) => {
  const el = document.getElementById(hash);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else if (attempts < 12) {
    setTimeout(() => tryScroll(hash, attempts + 1), 150);
  }
};

export default function SmartLink({ to, children, onClick, ...rest }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handle = (e) => {
    if (to.includes("#")) {
      e.preventDefault();
      const [path, hash] = to.split("#");
      const target = path || "/";
      if (location.pathname === target) {
        tryScroll(hash);
      } else {
        navigate(target);
        setTimeout(() => tryScroll(hash), 150);
      }
    }
    onClick?.();
  };

  const plainTo = to.includes("#") ? to.split("#")[0] || "/" : to;
  return (
    <Link to={plainTo} onClick={handle} {...rest}>
      {children}
    </Link>
  );
}
